import React from 'react';
import PanelTable from '../Panel/PanelTable';
import Panel from '../Panel';

import './PaginatedList.scss';

export default function PaginatedList({ render, order, activeOrder, dir, headers = [], items = [] })
{
    return (
        <>
            <Panel
                panelStyle={{
                    marginTop: 40,
                    overflow: 'hidden'
                }}
                contentStyle={{
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingBottom: 0
                }}
                headerStyle={{
                    display: 'none'
                }}

            >
                <PanelTable
                    headers={headers}
                    order={order}
                    activeOrder={activeOrder}
                    dir={dir}
                    items={items}
                    render={render}
                    panelStyle={{ 
                        margin: 0,
                    }}
                    thStyle={{
                        borderTop: 'none'
                    }}
                ></PanelTable>
            </Panel>
        </>
    )
}